import { useEffect } from 'react';

interface UsePositionFixedProps {
  isOpen: boolean;
  modal: boolean;
  hasBeenOpened: boolean;
  preventScrollRestoration: boolean;
  noBodyStyles: boolean;
}

export function usePositionFixed({
  isOpen,
  modal,
  hasBeenOpened,
  preventScrollRestoration,
  noBodyStyles,
}: UsePositionFixedProps) {
  useEffect(() => {
    if (noBodyStyles) return;

    const scrollY = window.scrollY;

    if (isOpen && modal) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    }

    return () => {
      if (modal) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        if (!preventScrollRestoration) {
          window.scrollTo(0, scrollY);
        }
      }
    };
  }, [isOpen, modal, hasBeenOpened, preventScrollRestoration, noBodyStyles]);

  const restorePositionSetting = () => {
    if (noBodyStyles) return;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  };

  return { restorePositionSetting };
}
